<script setup lang="ts">
import SparkIcon from '@/components/icons/SparkIcon.vue'
import { useMinesweeperChallenge } from '@/composables/game/challenges'
import MinesweeperChallengeIcon from '@/assets/images/challenges/minesweeper/minesweeper-challenge-button.webp'

const { countdown, formattedCountdown, isMinesweeperChallengeLive } = useMinesweeperChallenge()
</script>

<template>
  <div
    v-if="isMinesweeperChallengeLive"
    class="flex flex-col items-center justify-center"
  >
    <div class="relative flex items-center justify-center size-12 rounded-[15px]">
      <SparkIcon class="absolute sparkling-star h-4 w-4 z-[10]" />
      <img
        class="size-full object-cover z-[3]"
        :src="MinesweeperChallengeIcon"
      >
    </div>
    <div class="z-[10] flex flex-col -mt-2 items-center">
      <div class="z-[2] whitespace-nowrap h-[18px] px-1.5 rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] text-tropee-black">
        Minesweeper
      </div>
      <div
        class="z-[1] -mt-1 whitespace-nowrap h-[18px] px-1.5 rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] tabular-nums"
        :class="countdown < (3600 * 3) ? 'text-red-danger' : 'text-tropee-black'"
      >
        {{ formattedCountdown }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.sparkling-star {
  top: 4px;
  right: 4px;
  animation: sparkle 2.5s infinite;
  transition: all;
  transition-delay: 200ms;
}

@keyframes sparkle {
  0% {
    bottom: auto;
    left: auto;
    top: 4px;
    right: 4px;
    opacity: 1;
  }
  20% {
    bottom: auto;
    left: auto;
    top: 4px;
    right: 4px;
    opacity: 0;
  }
  35% {
    top: auto;
    right: auto;
    bottom: 4px;
    left: 4px;
    opacity: 0;
  }
  50% {
    top: auto;
    right: auto;
    bottom: 4px;
    left: 4px;
    opacity: 1;
  }
  70% {
    top: auto;
    right: auto;
    bottom: 4px;
    left: 4px;
    opacity: 0;
  }
  85% {
    bottom: auto;
    left: auto;
    top: 4px;
    right: 4px;
    opacity: 0;
  }
  100% {
    bottom: auto;
    left: auto;
    top: 4px;
    right: 4px;
    opacity: 1;
  }
}

.minesweeper-gradient-background {
  background: linear-gradient(180deg, #52EDCC 0.01%, #4FAF5C 23.08%, #000 36.54%)
}

.green-blur {
  background: #1AC080;
  filter: blur(9px);
}

.minesweeper-challenge-button::before {
  background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.4) 0%,
      rgba(255, 255, 255, 1) 50%,
      rgba(255, 255, 255, 0.4) 100%
  );
  border-radius: 15px;
  content: "";
  inset: 0;
  -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  -webkit-mask-composite: xor;
  mask-composite: exclude;
  padding: 2px; /* this is the border width */
  position: absolute;
  z-index: 10;
  pointer-events: none;
}
</style>